import React, { useState } from 'react'
import { inject } from 'mobx-react'
import { observer } from 'mobx-react-lite'
import { CurrentCompanyStore } from '../../../../../stores/CurrentCompanyStore'
import { CurrentUserStore } from '../../../../../stores/CurrentUserStore'
import { DiscountFilter } from '../../Discounts/DiscountFilter'
import { Button, Checkbox, Dropdown, Input, Menu } from 'antd-v4'
import { BlazeButton } from '../../../../../components/CustomButtons/BlazeButton'
import { DownOutlined, SearchOutlined } from '@ant-design/icons'
import { getPopupContainer } from '../../../../../utilities/helpers'

interface InjectedProps {
  currentCompanyStore?: CurrentCompanyStore
  currentUserStore?: CurrentUserStore
}

interface Props extends InjectedProps {
  filter: DiscountFilter
  onApplyFilter: () => void
}

export const FilterGroup: React.FC<Props> = inject('currentCompanyStore')(
  observer(({ currentCompanyStore, filter, onApplyFilter }) => {
    const [isloading, setIsLoading] = useState(false)

    const getLocationOptions = () =>
      (currentCompanyStore!.globalLocations || []).map((location) => ({
        value: location.id,
        label: location.name,
      }))

    const checkboxStyle = () => ({
      textAlign: 'center' as const,
      height: '24px',
      borderStyle: 'solid',
      borderWidth: '1px',
      borderColor: '#d9d9d9',
      padding: '0px 4px',
      marginRight: '5px',
    })

    return (
      <>
        <div className='mb-2' style={{ display: 'flex', flexWrap: 'wrap' }}>
          <div className='mr-1 mb-2' style={{ width: 160 }}>
            <Input
              value={filter.searchTerm}
              size='small'
              onChange={(e) => filter.setSearchTerm(e.target.value)}
              placeholder={'Discount name, ID'}
              prefix={<SearchOutlined />}
            />
          </div>

          <Dropdown
            className='gr-filter-item gr-filter-gutter mr-1'
            getPopupContainer={getPopupContainer}
            trigger={['click']}
            overlay={
              <Menu>
                {getLocationOptions().map((option: any) => {
                  return (
                    <Menu.Item key={option.value} disabled style={{ padding: 0 }}>
                      <Checkbox
                        checked={filter.locationIds?.includes(option.value)}
                        className='w-100'
                        style={{ padding: '5px 12px', fontWeight: 400 }}
                        onChange={(e) => {
                          if (e.target.checked) {
                            filter.addLocationId(option.value)
                          } else {
                            filter.removeLocationId(option.value)
                          }
                        }}
                      >
                        {option.label}
                      </Checkbox>
                    </Menu.Item>
                  )
                })}
              </Menu>
            }
          >
            <Button
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                width: '120px',
              }}
              size='small'
            >
              Locations ({(filter.locationIds || []).length})
              <DownOutlined className='mt-1' />
            </Button>
          </Dropdown>

          <div style={checkboxStyle()}>
            <Checkbox
              checked={filter.isLoyalty}
              style={{ fontWeight: 400 }}
              onChange={(e) => {
                filter.setIsLoyalty(e.target.checked || undefined)
              }}
            >
              Loyalty
            </Checkbox>
          </div>

          <div style={checkboxStyle()}>
            <Checkbox
              checked={filter.isAutomatic}
              style={{ fontWeight: 400 }}
              onChange={(e) => {
                filter.setIsAutomatic(e.target.checked || undefined)
              }}
            >
              Automatic
            </Checkbox>
          </div>

          <BlazeButton
            buttonProps={{
              type: 'primary',
              size: 'small',
              className: 'mr-1',
              loading: isloading,
              onClick: () => {
                setIsLoading(true)
                onApplyFilter()
                setIsLoading(false)
              },
            }}
            titleProps={{ title: 'Apply' }}
          />

          <BlazeButton
            buttonProps={{
              size: 'small',
              onClick: () => {
                filter.reset()
                onApplyFilter()
              },
              disabled: filter.isFilterEmpty,
            }}
            titleProps={{ title: 'Reset' }}
          />
        </div>
      </>
    )
  }),
)
